<template>
  <div class="dialog" :class="{ show: isShown }">
    <div class="content">
      <div class="top">
        <div class="title">Delete?</div>
      </div>
      <div class="body">
        <p>All changes will be lost.</p>
      </div>
      <div class="bottom">
        <button class="btn" @click="close">Cancel</button>
        <button class="btn warning" @click="onDelete">
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShown: false
    };
  },
  methods: {
    show() {
      this.isShown = true;
    },
    close() {
      this.isShown = false;
    },
    onDelete() {
      this.close();
      this.$emit('deleted');
    }
  }
};
</script>
